import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import LegalDocument from "@/components/feature/LegalDocument";

interface PolicySection {
  heading: string;
  body: string;
}

export default function TermsPage() {
  const { t } = useTranslation();

  const sections: PolicySection[] = t("termsOfService.sections", { returnObjects: true }) as unknown as PolicySection[];

  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <LegalDocument
        title={t("termsOfService.title")}
        lastUpdated={t("termsOfService.lastUpdated")}
        sections={sections}
      />
      <Footer />
    </div>
  );
}